// Report utility functions

export const generateReportCode = (reportNumber: number): string => {
  const paddedNumber = String(reportNumber).padStart(5, '0');
  const year = new Date().getFullYear();
  return `PRJ-${year}${paddedNumber}`;
};

export const getNextReportNumber = (existingReports: any[]): number => {
  if (existingReports.length === 0) {
    return 1;
  }

  const lastReport = existingReports[existingReports.length - 1];
  const lastCode = lastReport.nomorLaporan || lastReport.no;

  // Parse the number from PRJ-YYYYXXXXX format
  const lastNumber = parseInt(lastCode.substring(lastCode.length - 5));
  return lastNumber + 1;
};

export const REPORT_TYPES = [
  'Harian',
  'Mingguan',
  'Bulanan',
  'Progress',
  'Final'
];
